enum ProcessingState {
    Idle = 'Idle',
    Success = 'Success',
    Processing = 'Processing',
    Error = 'Error',
}

export default ProcessingState;
